import { theme } from "../../ui-kit/src/theme"

export function getColorByScheme(
    scheme: string | null,
    type: string = 'button',
    variant: string = 'primaryHoverBackground'
  ): string {
    if (!scheme || !theme.colorScheme[scheme]) return 'white'
    return theme.colorScheme[scheme][type][variant]
      ? theme.colorScheme[scheme][type][variant]
      : theme.colorScheme[scheme]
  }